import { all } from 'redux-saga/effects';
import manageEmployeeWatcher from './employeeSaga';

export default function* rootSaga(action) {
	yield all([manageEmployeeWatcher(action)]);
}
